export function isNative(): boolean {
  return false;
}
